import React from "react";
import { ParagraphText, UBRadioBox } from "../../../../../Libraries";

const SortTabContent = ({ I18n, filterOp, setFilterOp }) => {
  const SortFilter = ["Recent", "Amount (High - Low)", "Amount (Low - High)"];

  return (
    <div className="w-100">
      <ParagraphText className="fontWeight700 fontSize16">
        {I18n.sort}
      </ParagraphText>
      <div className="filterRadioOptionList marginTop20 invoiceSort">
        {SortFilter.map((sf, ind) => (
          <UBRadioBox
            key={ind}
            index={ind}
            label={sf}
            onChange={(value) => {
              setFilterOp((f) => ({ ...f, sort: value }));
            }}
            value={filterOp.sort}
          />
        ))}
      </div>
    </div>
  );
};

export default SortTabContent;
